// extracted by mini-css-extract-plugin
export default {"container":"FeriasUniversitarias_container__EQWdh","wrapper":"FeriasUniversitarias_wrapper__uLJAf","content":"FeriasUniversitarias_content__puels"};